import React, { Component, PropTypes } from 'react';
import './Kakuna.scss';

class Kakuna extends Component {
  render() {
    return (
      <div className="pokemon">
        <div className="kakuna">
          <div className="head">

          </div>
          <div className="body">

          </div>
        </div>
      </div>
    );
  }
}

export default Kakuna;



/** WEBPACK FOOTER **
 ** ./source/014-kakuna/Kakuna.js
 **/